import { z } from 'zod'

export const internalReviewSchema = z.object({
  status: z.enum(['draft', 'submitted', 'approved', 'rejected']),
  draftRevision: z.number().int(),
  reviewRevision: z.number().int().nullable(),
  publishedRevision: z.number().int().nullable(),
  issues: z.array(z.unknown()),
  authorSubmitRequired: z.literal(false),
})
export const publicationSchema = z.object({
  published: z.boolean(),
  version: z.number().int(),
  visibility: z.enum(['public', 'link', 'private']),
  homeEligible: z.boolean(),
})
